import { formatPrice } from "./formatPrice";

// Formats prices stored in cents, includes dollar sign, ie.. 500 -> $5, 499 -> $4.99
export function formatPriceFromCents(price: number): string {
  return `$${formatPrice(price / 100)}`;
}

// A price in dollars as whole cents, rounded once: 0.29 -> 29 (0.29 * 100 is 28.999999999999996).
export function dollarsToCents(dollars: number): number {
  return Math.round(dollars * 100);
}

/** Whole cents → "$1,234.50", always two decimals (formatPriceFromCents strips ".00"; table cells and totals need it kept). */
export function formatCentsUsd(cents: number): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(cents / 100);
}
